<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dense elevation="0" v-if="!!title">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>

      <v-divider class="mx-2" v-if="!!title" />

      <v-card-text
        class="pa-5 text-md-body-1 text--black"
        v-show="!!message"
        v-html="message"
      ></v-card-text>

      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn v-for="button in options.buttons" :key="button.name"
               :color="button.color"
               elevation="0"
               class="ml-4"
               @click.native="finish(button.result)"
        >{{ button.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",

  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "grey lighten-3",
        width: 400,
        zIndex: 5000,
        buttons: [
          { name: "cancel", text: this.$t("dialog.confirm.button_cancel"), result: false, color: "gray" },
          { name: "ok", text: this.$t("dialog.confirm.button_ok"), result: true, color: "primary" }
        ]
      }
    };
  },

  methods: {
    open(message, title, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    finish(result) {
      this.resolve(result);
      this.dialog = false;
    }
  }
};
</script>
>

<style scoped>

</style>